'use strict'; // @ts-ignore

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var SparseArray = require('sparse-array');

var _require = require('uint8arrays/from-string'),
    uint8ArrayFromString = _require.fromString;
/**
 * @typedef {import('./consumable-hash').InfiniteHash} InfiniteHash
 * @typedef {import('../').UserBucketOptions} UserBucketOptions
 */

/**
 * @template V
 * @typedef {object} BucketChild<V>
 * @property {string} key
 * @property {V} value
 * @property {InfiniteHash} hash
 */

/**
 * @template B
 *
 * @typedef {object} SA<B>
 * @property {number} length
 * @property {() => B[]} compactArray
 * @property {(i: number) => B} get
 * @property {(i: number, value: B) => void} set
 * @property {<A> (fn: (acc: A, curr: B, index: number) => A, initial: A) => B} reduce
 * @property {(fn: (item: B) => boolean) => B | undefined} find
 * @property {() => number[]} bitField
 * @property {(i: number) => void} unset
 */

/**
 * @template T
 *
 * @typedef {object} BucketPosition<T>
 * @property {Bucket<T>} bucket
 * @property {number} pos
 * @property {InfiniteHash} hash
 * @property {BucketChild<T>} [existingChild]
 */

/**
 * @typedef {object} BucketOptions
 * @property {number} bits
 * @property {(value: Uint8Array | InfiniteHash) => InfiniteHash} hash
 */

/**
 * @template T
 */


var Bucket = /*#__PURE__*/function () {
  /**
   * @param {BucketOptions} options
   * @param {Bucket<T>} [parent]
   * @param {number} [posAtParent=0]
   */
  function Bucket(options, parent) {
    var posAtParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck(this, Bucket);

    this._options = options;
    this._popCount = 0;
    this._parent = parent;
    this._posAtParent = posAtParent;
    /** @type {SA<Bucket<T> | BucketChild<T>>} */

    this._children = new SparseArray();
    /** @type {string | null} */

    this.key = null;
  }
  /**
   * @param {string} key
   * @param {T} value
   */


  _createClass(Bucket, [{
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key, value) {
        var place;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._findNewBucketAndPos(key);

              case 2:
                place = _context.sent;
                _context.next = 5;
                return place.bucket._putAt(place, key, value);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function put(_x, _x2) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
    /**
     * @param {string} key
     */

  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key) {
        var child;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._findChild(key);

              case 2:
                child = _context2.sent;

                if (!child) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", child.value);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function get(_x3) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
    /**
     * @param {string} key
     */

  }, {
    key: "del",
    value: function () {
      var _del = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key) {
        var place, child;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this._findPlace(key);

              case 2:
                place = _context3.sent;
                child = place.bucket._at(place.pos);

                if (child && child.key === key) {
                  place.bucket._delAt(place.pos);
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function del(_x4) {
        return _del.apply(this, arguments);
      }

      return del;
    }()
    /**
     * @returns {number}
     */

  }, {
    key: "leafCount",
    value: function leafCount() {
      var children = this._children.compactArray();

      return children.reduce(function (acc, child) {
        if (child instanceof Bucket) {
          return acc + child.leafCount();
        }

        return acc + 1;
      }, 0);
    }
  }, {
    key: "childrenCount",
    value: function childrenCount() {
      return this._children.length;
    }
  }, {
    key: "onlyChild",
    value: function onlyChild() {
      return this._children.get(0);
    }
    /**
     * @returns {Iterable<BucketChild<T>>}
     */

  }, {
    key: "eachLeafSeries",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function eachLeafSeries() {
      var children, _iterator, _step, child;

      return _regeneratorRuntime.wrap(function eachLeafSeries$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              children = this._children.compactArray();
              _iterator = _createForOfIteratorHelper(children);
              _context4.prev = 2;

              _iterator.s();

            case 4:
              if ((_step = _iterator.n()).done) {
                _context4.next = 14;
                break;
              }

              child = _step.value;

              if (!(child instanceof Bucket)) {
                _context4.next = 10;
                break;
              }

              return _context4.delegateYield(child.eachLeafSeries(), "t0", 8);

            case 8:
              _context4.next = 12;
              break;

            case 10:
              _context4.next = 12;
              return child;

            case 12:
              _context4.next = 4;
              break;

            case 14:
              _context4.next = 19;
              break;

            case 16:
              _context4.prev = 16;
              _context4.t1 = _context4["catch"](2);

              _iterator.e(_context4.t1);

            case 19:
              _context4.prev = 19;

              _iterator.f();

              return _context4.finish(19);

            case 22:
              return _context4.abrupt("return", []);

            case 23:
            case "end":
              return _context4.stop();
          }
        }
      }, eachLeafSeries, this, [[2, 16, 19, 22]]);
    })
    /**
     * @param {(value: BucketChild<T>, index: number) => T} map
     * @param {(reduced: any) => any} reduce
     */

  }, {
    key: "serialize",
    value: function serialize(map, reduce) {
      /** @type {T[]} */
      var acc = []; // serialize to a custom non-sparse representation

      return reduce(this._children.reduce(function (acc, child, index) {
        if (child) {
          if (child instanceof Bucket) {
            acc.push(child.serialize(map, reduce));
          } else {
            acc.push(map(child, index));
          }
        }

        return acc;
      }, acc));
    }
    /**
     * @param {(value: BucketChild<T>) => Promise<T[]>} asyncMap
     * @param {(reduced: any) => Promise<any>} asyncReduce
     */

  }, {
    key: "asyncTransform",
    value: function asyncTransform(asyncMap, asyncReduce) {
      return asyncTransformBucket(this, asyncMap, asyncReduce);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.serialize(mapNode, reduceNodes);
    }
  }, {
    key: "prettyPrint",
    value: function prettyPrint() {
      return JSON.stringify(this.toJSON(), null, '  ');
    }
  }, {
    key: "tableSize",
    value: function tableSize() {
      return Math.pow(2, this._options.bits);
    }
    /**
     * @param {string} key
     * @returns {Promise<BucketChild<T> | undefined>}
     */

  }, {
    key: "_findChild",
    value: function () {
      var _findChild2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(key) {
        var result, child;
        return _regeneratorRuntime.wrap(function _callee4$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._findPlace(key);

              case 2:
                result = _context5.sent;
                child = result.bucket._at(result.pos);

                if (!(child instanceof Bucket)) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return", undefined);

              case 6:
                if (!(child && child.key === key)) {
                  _context5.next = 8;
                  break;
                }

                return _context5.abrupt("return", child);

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee4, this);
      }));

      function _findChild(_x5) {
        return _findChild2.apply(this, arguments);
      }

      return _findChild;
    }()
    /**
     * @param {string | InfiniteHash} key
     * @returns {Promise<BucketPosition<T>>}
     */

  }, {
    key: "_findPlace",
    value: function () {
      var _findPlace2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(key) {
        var hashValue, index, child;
        return _regeneratorRuntime.wrap(function _callee5$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                hashValue = this._options.hash(typeof key === 'string' ? uint8ArrayFromString(key) : key);
                _context6.next = 3;
                return hashValue.take(this._options.bits);

              case 3:
                index = _context6.sent;
                child = this._children.get(index);

                if (!(child instanceof Bucket)) {
                  _context6.next = 7;
                  break;
                }

                return _context6.abrupt("return", child._findPlace(hashValue));

              case 7:
                return _context6.abrupt("return", {
                  bucket: this,
                  pos: index,
                  hash: hashValue,
                  existingChild: child
                });

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee5, this);
      }));

      function _findPlace(_x6) {
        return _findPlace2.apply(this, arguments);
      }

      return _findPlace;
    }()
    /**
     * @param {string | InfiniteHash} key
     * @returns {Promise<BucketPosition<T>>}
     */

  }, {
    key: "_findNewBucketAndPos",
    value: function () {
      var _findNewBucketAndPos2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(key) {
        var place, bucket, newPlace;
        return _regeneratorRuntime.wrap(function _callee6$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this._findPlace(key);

              case 2:
                place = _context7.sent;

                if (!(place.existingChild && place.existingChild.key !== key)) {
                  _context7.next = 11;
                  break;
                }

                // conflict
                bucket = new Bucket(this._options, place.bucket, place.pos);

                place.bucket._putObjectAt(place.pos, bucket); // put the previous value


                _context7.next = 8;
                return bucket._findPlace(place.existingChild.hash);

              case 8:
                newPlace = _context7.sent;

                newPlace.bucket._putAt(newPlace, place.existingChild.key, place.existingChild.value);

                return _context7.abrupt("return", bucket._findNewBucketAndPos(place.hash));

              case 11:
                return _context7.abrupt("return", place);

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee6, this);
      }));

      function _findNewBucketAndPos(_x7) {
        return _findNewBucketAndPos2.apply(this, arguments);
      }

      return _findNewBucketAndPos;
    }()
    /**
     * @param {BucketPosition<T>} place
     * @param {string} key
     * @param {T} value
     */

  }, {
    key: "_putAt",
    value: function _putAt(place, key, value) {
      this._putObjectAt(place.pos, {
        key: key,
        value: value,
        hash: place.hash
      });
    }
    /**
     * @param {number} pos
     * @param {Bucket<T> | BucketChild<T>} object
     */

  }, {
    key: "_putObjectAt",
    value: function _putObjectAt(pos, object) {
      if (!this._children.get(pos)) {
        this._popCount++;
      }

      this._children.set(pos, object);
    }
    /**
     * @param {number} pos
     */

  }, {
    key: "_delAt",
    value: function _delAt(pos) {
      if (pos === -1) {
        throw new Error('Invalid position');
      }

      if (this._children.get(pos)) {
        this._popCount--;
      }

      this._children.unset(pos);

      this._level();
    }
  }, {
    key: "_level",
    value: function _level() {
      if (this._parent && this._popCount <= 1) {
        if (this._popCount === 1) {
          // remove myself from parent, replacing me with my only child
          var onlyChild = this._children.find(exists);

          if (onlyChild && !(onlyChild instanceof Bucket)) {
            var hash = onlyChild.hash;
            hash.untake(this._options.bits);
            var place = {
              pos: this._posAtParent,
              hash: hash,
              bucket: this._parent
            };

            this._parent._putAt(place, onlyChild.key, onlyChild.value);
          }
        } else {
          this._parent._delAt(this._posAtParent);
        }
      }
    }
    /**
     * @param {number} index
     * @returns {BucketChild<T> | Bucket<T> | undefined}
     */

  }, {
    key: "_at",
    value: function _at(index) {
      return this._children.get(index);
    }
  }]);

  return Bucket;
}();
/**
 * @param {any} o
 */


function exists(o) {
  return Boolean(o);
}
/**
 *
 * @param {*} node
 * @param {number} index
 */


function mapNode(node, index) {
  return node.key;
}
/**
 * @param {*} nodes
 */


function reduceNodes(nodes) {
  return nodes;
}
/**
 * @template T
 *
 * @param {Bucket<T>} bucket
 * @param {(value: BucketChild<T>) => Promise<T[]>} asyncMap
 * @param {(reduced: any) => Promise<any>} asyncReduce
 */


function asyncTransformBucket(_x8, _x9, _x10) {
  return _asyncTransformBucket.apply(this, arguments);
}

function _asyncTransformBucket() {
  _asyncTransformBucket = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(bucket, asyncMap, asyncReduce) {
    var output, _iterator2, _step2, child, mappedChildren;

    return _regeneratorRuntime.wrap(function _callee7$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            output = [];
            _iterator2 = _createForOfIteratorHelper(bucket._children.compactArray());
            _context8.prev = 2;

            _iterator2.s();

          case 4:
            if ((_step2 = _iterator2.n()).done) {
              _context8.next = 17;
              break;
            }

            child = _step2.value;

            if (!(child instanceof Bucket)) {
              _context8.next = 11;
              break;
            }

            _context8.next = 9;
            return asyncTransformBucket(child, asyncMap, asyncReduce);

          case 9:
            _context8.next = 15;
            break;

          case 11:
            _context8.next = 13;
            return asyncMap(child);

          case 13:
            mappedChildren = _context8.sent;
            output.push({
              bitField: bucket._children.bitField(),
              children: mappedChildren
            });

          case 15:
            _context8.next = 4;
            break;

          case 17:
            _context8.next = 22;
            break;

          case 19:
            _context8.prev = 19;
            _context8.t0 = _context8["catch"](2);

            _iterator2.e(_context8.t0);

          case 22:
            _context8.prev = 22;

            _iterator2.f();

            return _context8.finish(22);

          case 25:
            return _context8.abrupt("return", asyncReduce(output));

          case 26:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee7, null, [[2, 19, 22, 25]]);
  }));
  return _asyncTransformBucket.apply(this, arguments);
}

module.exports = Bucket;